import { useMemo } from 'react'

import { EmbroideryOption } from '../../../../../types/graphql'

export type UseProductPageEmbroiderySettingsOpts = {
  defaultEmbroideryOptions: EmbroideryOption[] | null
  mandatoryLogoEmbroidery?: boolean
  isPortalColorSelected?: boolean
}
/**
 * Derive the embroidery settings based on the current product & user characteristics.
 */
export function useProductPageEmbroiderySettings({
  defaultEmbroideryOptions,
  isPortalColorSelected,
}: UseProductPageEmbroiderySettingsOpts) {
  // Whether or not the current product supports logo + text embroidery for portals
  const hasLogoOnlyEmbroidery = useMemo(() => {
    return defaultEmbroideryOptions?.some(({ kind }) => kind === 'LOGO_ONLY')
  }, [defaultEmbroideryOptions])

  // Derive embroidery options that should be present for the current product
  const embroideryOptions: ReadonlyArray<EmbroideryOption> = useMemo(() => {
    const defaultOptions = defaultEmbroideryOptions ?? []
    // Use portal-specific embroidery options if applicable portal color is selected
    if (isPortalColorSelected && hasLogoOnlyEmbroidery)
      return defaultOptions.filter(opt =>
        ['TEXT_ONLY', 'LOGO_ONLY', 'LOGO_TEXT'].includes(opt.kind)
      )

    return defaultOptions.filter(option => !['LOGO_ONLY', 'LOGO_TEXT'].includes(option.kind))
  }, [defaultEmbroideryOptions, isPortalColorSelected, hasLogoOnlyEmbroidery])

  return {
    embroideryOptions,
  }
}
